import type { IconProps } from './types';

export const Matrica = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none" aria-hidden="true" {...props}>
    <path
      d="M14.3594 2.72467V.275429c0-.124474.1009-.2253802.2254-.2253802h8.6492c.1245 0 .2254.1009062.2254.2253802V22.1247c0 .1244-.1009.2253-.2254.2253h-8.6492c-.1245 0-.2254-.1009-.2254-.2253v-2.6493c0-.1244.1009-.2254.2254-.2254h5.5492c.1245 0 .2254-.1009.2254-.2253V3.17543c0-.12448-.1009-.22538-.2254-.22538h-5.5492c-.1245 0-.2254-.10091-.2254-.22538Z"
      fill="currentColor"
    />
    <path
      d="M9.96094 2.72467V.275429c0-.124474-.10091-.2253802-.22538-.2253802H1.08632c-.124477 0-.225383.1009062-.225383.2253802V22.1247c0 .1244.100906.2253.225383.2253h8.64924c.12447 0 .22538-.1009.22538-.2253v-2.6493c0-.1244-.10091-.2254-.22538-.2254H4.18632c-.12448 0-.22538-.1009-.22538-.2253V3.17543c0-.12448.1009-.22538.22538-.22538h5.54924c.12447 0 .22538-.10091.22538-.22538Z"
      fill="currentColor"
    />
    <path
      d="M15.134 8.05005H9.08475c-.12447 0-.22537.1009-.22537.22538v5.94927c0 .1244.1009.2253.22537.2253H15.134c.1245 0 .2254-.1009.2254-.2253V8.27543c0-.12448-.1009-.22538-.2254-.22538Z"
      fill="currentColor"
    />
  </svg>
);
